export const iconFontAwesomeGamingChessBishop = (
	<i className="fa-solid fa-chess-bishop"></i>
);
